
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.811 29.2316L9.09218 10.1827C8.73507 9.48281 9.48281 8.73507 10.1827 9.09218L29.2316 18.811C29.9162 19.1603 29.7758 20.1773 29.0221 20.328L27.1307 20.7063C25.8609 20.9603 25.3865 22.527 26.3022 23.4427L31.5251 28.6656C32.1583 29.2988 32.1583 30.3254 31.5251 30.9586L30.9586 31.5251C30.3254 32.1583 29.2988 32.1583 28.6656 31.5251L23.4427 26.3022C22.527 25.3865 20.9603 25.8609 20.7063 27.1307L20.328 29.0221C20.1773 29.7758 19.1603 29.9162 18.811 29.2316Z","fill":"#0093FF"}}),_c('path',{attrs:{"d":"M7 0.5V5.5M5.5 7H0.5M7 13.5V8.5M8.5 7H13.5","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    